import React, { useMemo } from 'react'
import MerchandiseOfferCarousel from 'components/Merchandise/MerchandiseCarousels/MerchandiseOfferCarousel'
import useMerchandiseCategory from 'hooks/Merchandise/useMerchandiseCategory'
import { getMerchandiseCategorySearchUrl } from 'components/Merchandise/merchandiseUtils'

const GOLF_CATEGORY_SLUG = 'golf'
const GOLF_TRACKING_PAGE_NAME = 'Golf Campaign Page'
const GOLF_TRACKING_LIST_NAME = 'Tee Off in Style with Premium Golf Essentials'
const GOLF_CAROUSEL_TITLE: React.ReactNode = <>Tee Off in Style with <i>Premium Golf Essentials</i></>

function GolfMerchandiseCategoryCarousel() {
  const [category] = useMerchandiseCategory({ slug: GOLF_CATEGORY_SLUG })

  const filters = useMemo<App.MerchandiseFilters | undefined>(() => {
    if (!category) { return undefined }
    return {
      categories: [category.id],
    }
  }, [category])

  const viewAllTo = useMemo<string | undefined>(() => {
    if (!category) { return undefined }
    return getMerchandiseCategorySearchUrl(category)
  }, [category])

  return <>
    {!!category && !!filters && !!viewAllTo && (
      <MerchandiseOfferCarousel
        title={GOLF_CAROUSEL_TITLE}
        filters={filters}
        viewAllTo={viewAllTo}
        trackingListName={GOLF_TRACKING_LIST_NAME}
        trackingPageName={GOLF_TRACKING_PAGE_NAME}
      />
    )}
  </>
}

export default GolfMerchandiseCategoryCarousel
